export class ConsolidationReportGenerateCtrl {
    downloadName = 'file.docx';
    reportLoading = false;
    buttonText = "Generate Report";
    downloadUrl = null;
    downloadMimeType = 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';
    downloadDefaultName = 'file.docx';

    constructor($scope, $http, notify) {
        'ngInject';
        this.$scope = $scope;
        this.$http = $http;
        this.notify = notify; // notify is assumed to be a function: notify(message, isError, reloadPage)
    }

    handleButtonClick(e, url) {
        this.generateAndDownloadReport(e, url);
    }

    generateAndDownloadReport(e, url) {
        if (url && url !== '') {
            this.reportLoading = true;
            this.buttonText = "Generating...";

            this.$http({
                url: url,
                method: 'GET',
                responseType: 'json'
            })
                .then((response) => {
                    if (response.data && response.data.success) {
                        this.downloadUrl = response.data.download_url;
                        this.downloadName = response.data.file_name || this.downloadDefaultName;
                        this.downloadMimeType = response.data.mime_type || 'application/vnd.openxmlformats-officedocument.wordprocessingml.document';

                        this.notify(response.data.message || "Report generated successfully.");
                        this.initiateDownload(this.downloadUrl, this.downloadName, this.downloadMimeType);
                    } else {
                        this.notify(response.data.message, true);
                    }
                })
                .catch((error) => {
                    console.error("Error generating Report:", error);
                    this.notify("An error occurred while generating the report.", true);
                })
                .finally(() => {
                    this.reportLoading = false;
                    this.buttonText = "Generate Report";
                });
        }
    }

    initiateDownload(url, filename, mimeType) {
        this.$http({
            url: url,
            method: 'GET',
            responseType: 'blob'
        })
            .then((response) => {
                if (response.data) {
                    const blob = new Blob([response.data], { type: mimeType });
                    const downloadUrl = window.URL.createObjectURL(blob);

                    const link = document.createElement('a');
                    link.href = downloadUrl;
                    link.download = filename;
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);

                    window.URL.revokeObjectURL(downloadUrl);
                }
            })
            .catch((error) => {
                console.error('Error downloading Report:', error);
                this.notify("An error occurred while downloading the report.", true);
            });
    }
}
